import { Box, FormControl as MuiFormControl, TextField } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const FormControl = styled(MuiFormControl)`
  width: 100%;
`

export const LabelBox = styled(Box)<{ disabled?: boolean }>`
  ${({ disabled }) => css`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      opacity: ${disabled ? 0.6 : 1};
    }
  `}
`

export const Label = styled.span<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    margin-bottom: 6px;
    opacity: ${disabled ? 0.6 : 1};
  `}
`

export const Input = styled(TextField)<{ isNegative?: boolean }>`
  ${({ theme, error, isNegative }) => css`
    width: 100%;

    .MuiInputBase-root {
      height: 48px;
      border-radius: 8px;
    }

    .MuiInputBase-input {
      font-size: 16px;
      padding: 12px 14px 11px 14px;
      color: ${isNegative ? theme.colors.error.color : theme.colors.gray.dark};
      -webkit-text-fill-color: ${isNegative ? theme.colors.error.color : theme.colors.gray.dark};

      &::placeholder {
        font-size: 16px;
        opacity: 0.5;
      }
    }

    .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
      border: 1px solid !important;
      border-color: ${error ? theme.colors.error.color : theme.colors.gray.dark} !important;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${error ? theme.colors.error.color : theme.colors.primary} !important;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 2px solid ${error ? theme.colors.error.color : theme.colors.primary} !important;
    }

    &.Mui-disabled,
    .MuiOutlinedInput-root.Mui-disabled,
    .MuiInputBase-root.Mui-disabled,
    .MuiInputBase-input.Mui-disabled {
      cursor: not-allowed !important;
    }

    .MuiOutlinedInput-root.Mui-disabled {
      background: ${theme.colors.gray.disabled} !important;
    }

    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.border.disabled} !important;
    }

    .MuiInputBase-input.Mui-disabled {
      color: ${theme.colors.gray.dark} !important;
      -webkit-text-fill-color: ${theme.colors.gray.dark} !important;
      opacity: 0.6 !important;
    }
  `}
`

export const ErrorMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    padding: 4px 0 0 0;
    color: ${theme.colors.error.color};
  `}
`
